import React from 'react';
import Home from 'react-icons/lib/io/home';

const NavItem =({title})=>{
    return(
        <div className="cairo-font">
        {title==="الرئيسية" ? <Home/> : ''}{title}
        </div>
    );
}

export default NavItem;


// WEBPACK FOOTER //
// ./src/components/nav/NavItem.js